// @ts-ignore 运行时拦截
import { request } from "@umijs/max";
import { PricingPlanVersionEnum } from "./types";

export interface OrderInfo {
  orderId: string;
  amount: number;
}

export interface IDuration {
  id: string;
  amount: number;
}

export enum ConsumptionType {
  /** 订阅版本 */
  MEMBER = "MEMBER",
  /** 续费订阅 */
  RENEW_MEMBER = "RENEW_MEMBER",
  /** 升级订阅 */
  UPGRADE_MEMBER = "UPGRADE_MEMBER",
}

export interface IServiceOrderDto {
  /** 套餐购买数量 */
  planNum: number;
  /** 套餐购买时长 */
  planDuration: IDuration;
  /** 消费类型 */
  consumptionType: ConsumptionType;
}

/**
 * 计算价格接口
 * @param data
 * @returns
 */
export function calcAmountService(data: Partial<IServiceOrderDto>) {
  return request<API.BaseResponse<{ amount: number }>>(
    "/api/damselfish-fee-center/orderInfo/orderConfirm",
    {
      method: "POST",
      data,
    }
  );
}

/**
 * 创建订单服务
 * @param data
 * @returns
 */
export function createOrderService(data: Partial<IServiceOrderDto>) {
  return request<API.BaseResponse<OrderInfo>>(
    "/api/damselfish-fee-center/orderInfo/createOrder",
    {
      method: "POST",
      data,
    }
  );
}

export enum PayType {
  /** 线下银行卡支付 */
  OFFLINE = "OFFLINE",
  /** 余额支付 */
  BALANCE = "BALANCE",
  /** 微信支付 */
  WECHAT = "WECHAT",
  /** 支付宝支付 */
  ALIPAY = "ALIPAY",
}

export interface RequestPayDto {
  orderId: string;
  payType: PayType;
  verCode: string;
  returnUrl?: string;
  qrcodeSize: number;
}

export enum DisplayPayStatusEnum {
  /** 等待同意协议，前端用 */
  WAIT_FOR_AGREE_TERMS = "WAIT_FOR_AGREE_TERMS",
  /** 二维码加载中，前端用 */
  QR_CODE_LOADING = "QR_CODE_LOADING",
  /** 二维码过期 */
  QR_CODE_EXPIRED = "QR_CODE_EXPIRED",
  /** 等待支付 */
  WAIT = "WAIT",
  /** 支付中 */
  PAYING = "PAYING",
  /** 支付成功 */
  DONE = "DONE",
  /** 支付取消 */
  CANCEL = "CANCEL",
}

export interface PayResult {
  payId: string;
  payStatus: DisplayPayStatusEnum;
  codeUrl: string;
  expireTime: number;
}

/**
 * 请求支付
 * @param dto
 * @returns
 */
export function requestPayService(dto: Partial<RequestPayDto>) {
  return request<API.BaseResponse<PayResult>>(
    "/api/damselfish-fee-center/payInfo/requestPay",
    {
      method: "POST",
      data: dto,
    }
  );
}

/**
 * 获取支付回调
 * @param params
 * @returns
 */
export function getPayCallbackService(params: { payId: string }) {
  return request<API.BaseResponse<DisplayPayStatusEnum>>(
    "/api/damselfish-fee-center/payInfo/getPayStatus",
    {
      params,
    }
  );
}

export type Balance = {
  cashBalance: number;
  depositBalance: number;
  giftBalance: number;
  level: "PERSON" | "ORG";
  totalBalance: number;
  unclearedAmount: number;
  canUseBalance: number;
};

/**
 * 查询余额
 * @returns
 */
export function getBalanceService() {
  return request<API.BaseResponse<Balance>>(
    "/api/damselfish-fee-center/userSearch/userBalanceInfo"
  );
}

/**
 * 计划购买只有消费
 */
export enum ChangeType {
  CONSUME = "CONSUME",
}

export function getVerCodeService(data: {
  businessId: string;
  changeType: ChangeType;
}) {
  return request<API.BaseResponse>(
    "/api/damselfish-fee-center/payInfo/getVerCode",
    {
      method: "POST",
      data,
    }
  );
}

/**
 * 获取用户账号信息
 * @returns
 */
export function getUserPhoneAndEmailService() {
  return request<API.BaseResponse<{ phone: string; email: string }>>(
    "/api/damselfish-fee-center/userSearch/account"
  );
}

/**
 * 获取用户订阅情况
 * @returns
 */
export const getMemberPlanDetailService = () => {
  return request<
    API.BaseNewResponse<{
      memberPlan: PricingPlanVersionEnum;
      endTime: string;
    }>
  >("/api/damselfish-fee-center/userSearch/memberPlanDetail");
};

interface IAutoRenewPlanResponse {
  status: number;
  plan?: PricingPlanVersionEnum;
}

/**
 * 自动续费订阅计划
 * @returns
 */
export const postAutoRenewPlanService = (data: {
  status: number;
  plan?: PricingPlanVersionEnum;
}) => {
  return request<API.BaseResponse<void>>(
    "/api/damselfish-fee-center/tenantInfo/autoRenewPlan",
    {
      method: "POST",
      data,
    }
  );
};

/**
 * 获取自动续费订阅计划
 * @returns
 */
export const getAutoRenewPlanService = () => {
  return request<API.BaseResponse<IAutoRenewPlanResponse>>(
    "/api/damselfish-fee-center/tenantInfo/getAutoRenewPlan"
  );
};
export interface IPlanResponse {
  goodsId: string;
  goodsName: string;
  amount: number;
  memberPlan: PricingPlanVersionEnum;
  isDiscount: boolean;
  discountAmount: number;
  timeUnit: "MONTH" | "YEAR";
}

/**
 * 获取价格信息
 * @returns
 */
export const getAllPlanService = () => {
  return request<API.BaseResponse<IPlanResponse[]>>(
    "/api/damselfish-fee-center/goods/getAllMemberGoods"
  );
};

export interface IPaySuccessInformation {
  orderId: string;
  payAmount: number;
  startTime: string;
  endTime: string;
  goodsName: string;
}

/**
 * 获取支付成功信息
 * @param payId
 * @returns
 */
export const getPaySuccessInformationService = (payId: string) => {
  return request<API.BaseResponse<IPaySuccessInformation>>(
    `/api/damselfish-fee-center/payInfo/getPaySuccessInfo?payId=${payId}`
  );
};
